import axios from 'v1/utils/axios';

import modalSettings from './settings/modal';
import notifications from './notifications';

const modals = function($container) {
  const container = $container || $('@body');
  const $modalOpenVideo = container.find($('@modalVideo'));
  const $openModal = container.find($('@openModal'));

  const openModal = (url) => {
    axios
      .get(url)
      .then((response) => {
        const { data } = response;

        $(data)
          .appendTo('body')
          .modal(modalSettings);
        notifications();
      })
      .catch((error) => console.log(error));
  };

  if ($openModal.length > 0) {
    $.each($openModal, function(e) {
      const $this = $(this);

      $this.on('click', (e) => {
        e.preventDefault();
        const $this = $(this);
        const $thisHref = $this.attr('href');

        openModal($thisHref);
        $this.blur();
      });
    });
  }

  $.each($modalOpenVideo, function(e) {
    const $this = $(this);

    $this.on('click', function(e) {
      const $this = $(this);
      const url = $this.attr('href');
      e.preventDefault();
      $this.blur();

      // container.on($.modal.OPEN, (event, modal) => {
      // });

      openModal(url);
    });
  });
};

export default modals;
